import React from "react";
import { Modal, Button } from "react-bootstrap";

const LeadDetailModal = ({ show, onHide, lead }) => {
  if (!lead) return null;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Damage Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Agent Name:</strong> {lead.agent_name}
        </p>

        <p>
          <strong>Phone Number:</strong> {lead.phone_number}
        </p>
        <p>
          <strong>Customer Name:</strong> {lead.customer_name}
        </p>
        <p>
          <strong>Business Name:</strong> {lead.business_name}
        </p>

        <p>
          <strong>Date : </strong> {formatDate(lead.timestamp)}
        </p>
        <p>
          <strong>Address:</strong> {lead.address}
        </p>
        <p>
          <strong>Email </strong> {lead.email}
        </p>
        <p>
          <strong>Business Category:</strong>{" "}
          {lead.business_category?.name || "-"}
        </p>

        <p>
          <strong>Interested:</strong> {lead.interested ? "Yes" : "No"}
        </p>

        <p>
          <strong>Rating:</strong> {lead.rating}
        </p>
        <p>
          <strong> Visit Remarks :</strong> {lead.remarks}
        </p>
        <p>
          <strong> Call Remarks :</strong> {lead.callremarks}
        </p>
        <p>
          <strong>Created At : </strong> {formatDate(lead.createdAt)}
        </p>
        <p>
          <strong>Created By:</strong>{" "}
          {lead.createdBy ? lead.createdBy.user_email : "-"}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LeadDetailModal;
